<template>
  <b-card no-body>
    <b-card-body>
      <b-card bg-variant="light">
        <b-form-row @keyup.enter="load">

          <!-- Primeira linha: Tombamento, Até, Data, Até -->
          <b-col cols="2">
            <lg-form-input
              type="number"
              v-model="form.numTombamento"
              label="Tomb.Histórico:"
              maxlength="8"
            />
          </b-col>
          <b-col cols="2">
            <lg-form-input
              type="number"
              v-model="form.numTombamentoAte"
              label="Tomb.Até:"
              maxlength="8"
            />
          </b-col>
          <b-col cols="2">
            <lg-form-date
              v-model="form.dataDe"
              label="Data:"
            />
          </b-col>
          <b-col cols="2">
            <lg-form-date
              v-model="form.dataAte"
              label="Até:"
            />
          </b-col>
          <b-col cols="4"></b-col>

          <!-- Segunda linha: Usuário, Unidade Adm., Botões -->
          <b-col cols="4" class="ml-3">
            <lg-finder-page-pessoa
              id="finderUsuario"
              label="Usuário:"
              @onselect="handleSelectResponsavel"
              v-model="form.usuario"
              :prefix="title"
            />
          </b-col>
          <b-col cols="5" >
            <lg-finder-page-unidade-administrativa
              id="finderUnidadeAdministrativa"
              v-model="form.unidadeAdministrativa"
              @onselect="handleSelectUnidadeAdministrativa"
              :prefix="title"
              :podeMudarDepartamento="this.item == null && temPrivilegioGerenciarPatrimonio()"
              :podeApagarDepartamento="this.item == null && temPrivilegioGerenciarPatrimonio()"
            />
          </b-col>
         
          <!-- Terceira linha: Justificativa, Local Armazenamento -->
          <b-col cols="4" class="mt-2">
            <lg-form-input
              v-model="form.justificativa"
              label="Justificativa:"
            />
          </b-col>
          <b-col cols="5" class="mt-2 ml-3">
            <lg-finder-page-local-armazenamento
              :departamento="form.unidadeAdministrativa"
              v-model="form.localArmazenamento"
              id="finderLocal"
              @close="handleSelectLocal"
              :prefix="title"
              :podeMudar="this.item == null"
              :podeApagar="this.item == null"
            />
          </b-col>
          <b-col cols="2" ></b-col>

          <!-- Quarta linha: Tipo de Problema, Item -->
          <b-col cols="4" class="mt-2 ml-3">
            <lg-finder-page-tipo-problema
              :departamento="form.tipoProblema"
              v-model="form.tipoProblema"
              id="finderTipoProblema"
              @onselect="handleTipoProblema"
              :prefix="title"
            />
          </b-col>
          <b-col cols="5" class="mt-2">
            <lg-finder-page-item-bem-permanente
              :label="'Item:'"
              v-model="form.itemBemPermanente"
              id="finderItem"
              @close="handleSelectLocal"
              :prefix="title"
              :podeMudar="this.item == null"
              :podeApagar="this.item == null"
            />
          </b-col>
           <b-col cols="2" class="text-right ml-4 d-flex align-items-end justify-content-end">
            <b-button
              id="limpar"
              class="mr-2"
              size="sm"
              style="height: 36px"
              pill
              variant="primary"
              @click="clearForm"
            >
              <div class="btn-size-alinhamento">
                <b-icon icon="eraser" />
              </div>
              <b-tooltip target="limpar" title="Limpar"></b-tooltip>
            </b-button>
            <b-button
              id="localizar"
              size="sm"
              style="height: 36px"
              pill
              variant="primary"
              @click="load"
            >
              <div class="btn-size-alinhamento">
                <b-icon icon="search" />
              </div>
              <b-tooltip target="localizar" title="Localizar"></b-tooltip>
            </b-button>
          </b-col>

          <b-col cols="2" class="mt-2"></b-col>

        </b-form-row>


        

                <b-table responsive class="mt-2" small :busy="this.busy" :items="this.records"
                    :fields="this.tableFields" :hover="true" show-empty>
                    <template #table-busy>
                        <div class="text-center text-primary my-2">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                    </template>
                    <template #empty>
                        <p>Nenhum registro encontrado</p>
                    </template>


                </b-table>
                <b-row style="margin-top: 12px" v-if="records && records.length > 0">
                    <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">
                        <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Página {{ page }} de
                            {{
                                totalPage }} -
                            {{ total }} registros</b-col>
                        <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Mostrando:&nbsp;
                            <b-form-select size="sm" v-model="perPage" @change="() => this.load()"
                                :options="perPageOptions">
                            </b-form-select>
                        </b-col>
                    </b-col>
                    <b-col cols="6">
                        <div class="d-flex justify-content-end align-items-end">
                            <b-pagination style="margin-bottom: 10px; margin-top: 10px" v-model="page"
                                :per-page="perPage" :total-rows="total"></b-pagination>
                        </div>
                    </b-col>
                </b-row>
            </b-card>
        </b-card-body>
    </b-card>
</template>

<script>
import LgFinderPageLocalArmazenamento from "@/components/Finders/LgFinderPageLocalArmazenamento.vue";

import ResourceService from "@/core/api/ResourceService"
import LgFinderPageUnidadeAdministrativa from "@/components/Finders/LgFinderPageUnidadeAdministrativa.vue";
import ConfirmMixin from "@/core/mixins/confirm"
import { ListResourceMixin } from "@/core/mixins/resource"
import LgFormDate from "@/core/components/Form/LgFormDate.vue";
import LgFormInput from "@/core/components/Form/LgFormInput.vue";
import LgFinderPagePessoa from "@/components/Finders/LgFinderPagePessoa.vue";
import LgFinderPageItemBemPermanente from "@/components/Finders/LgFinderPageItemBemPermanente.vue";
import LgFinderPageTipoProblema from "@/components/Finders/LgFinderPageTipoProblema.vue";
import verificaPrivilegio from "@/utils/VerificaPrivilegio"
import PrivilegiosEnum from "@/core/utils/PrivilegioEnum"

export default {
    components: {
        LgFinderPageUnidadeAdministrativa,
        LgFormDate,
        LgFormInput,
        LgFinderPagePessoa,
        LgFinderPageLocalArmazenamento,
        LgFinderPageItemBemPermanente,
        LgFinderPageTipoProblema
    },
    mixins: [ConfirmMixin, ListResourceMixin],
    props: {
        item: Object
    },
    created() {

        if (this.item && this.item.id) {
            this.form.unidadeAdministrativa = this.item.lotacao.departamento;
            this.form.localArmazenamento = this.item.localArmazenamento;
            this.form.itemBemPermanente = this.item;
            this.form.itemBemPermanente.descricaoResumida = this.form.itemBemPermanente.itemRegEntrada.produto.descricaoResumida;
        }
        else {
            const brand = JSON.parse(localStorage.getItem("context"));
            this.form.unidadeAdministrativa = brand.departamento;
        }
        this.form.unidadeAdministrativa.descricao = this.form.unidadeAdministrativa.nome;

    },

    data() {
        return {
            title: 'Histórico de Tombamento > ',
            filtro: {},
            form: {
                tipoProblema: {},
                itemBemPermanente: {},
                usuario: {},
                numTombamento: '',
                numTombamentoAte: '',
                dataDe: null,
                dataAte: null,
                unidadeAdministrativa: {},
                justificativa: '',
            },
            records: [],
            perPage: 10,
            perPageOptions: [10, 25, 50, 100],
        };
    },
    watch: {
        page() {
            this.load();
        },
    },

    async beforeMount() {
        this.$service = new ResourceService(`/api/historicotombamento`)
        this.load();
    },

    computed: {
        departamentoFromStore() {
            return this.$store.getters.getMenuDepartamento;
        },

        tableFields() {
            return [
                {
                    key: "item.numTombamento",
                    label: "Tomb.Histórico",
                },

                {
                    key: "item.s_numTombAntigo",
                    label: "Tomb.Atual",
                },

                {
                    key: "dataTombamento",
                    label: "Data",
                    formatter: (value) =>
                        value ? new Date(value).toLocaleDateString() : "-",

                },

                {
                    key: "responsavelHistoricoTombamento",
                    label: "Usuário",
                },

                {
                    key: "justificativa",
                    label: "Justificativa",
                },

                {
                    key: "tipoProblema.descricao",
                    label: "Tipo de Problema",
                },

                {
                    key: "item.lotacao.departamento.descricao",
                    label: "Unidade Adm.",
                },

                {
                    key: "item.localArmazenamento.descricao",
                    label: "Local Armaz.",
                },

            ];
        },
    },
    methods: {
        temPrivilegioGerenciarPatrimonio() {
            return verificaPrivilegio(PrivilegiosEnum.GERENCIAR_PATRIMONIO);

        },

        async load() {

            this.busy = true;

            this.form.perPage = this.perPage;
            this.form.page = this.page;

            this.filtro = {};


            if (this.form.dataDe) {
                this.filtro.dataDe = new Date(
                    this.form.dataDe
                ).toLocaleDateString();
            }
            if (this.form.dataAte) {
                this.filtro.dataAte = new Date(
                    this.form.dataAte
                ).toLocaleDateString();
            }


            if (this.form.usuario.id && this.form.usuario.id)
                this.filtro.usuario = this.form.usuario.id;

            if (this.form.localArmazenamento && this.form.localArmazenamento.id)
                this.filtro.localArmazenamento = this.form.localArmazenamento.id;

            if (this.form.tipoProblema && this.form.tipoProblema.id)
                this.filtro.tipoProblema = this.form.tipoProblema.id;

            if (this.form.itemBemPermanente && this.form.itemBemPermanente.id)
                this.filtro.item = this.form.itemBemPermanente.id;

            this.filtro.unidadeAdministrativa = this.form.unidadeAdministrativa.id;

            if (this.form.justificativa && this.form.justificativa != "")
                this.filtro.justificativa = this.form.justificativa;


            if (this.form.numTombamento && this.form.numTombamento != "")
                this.filtro.tombHistorico = this.form.numTombamento;

            if (this.form.numTombamentoAte && this.form.numTombamentoAte != "")
                this.filtro.ate = this.form.numTombamentoAte;


            this.busy = true
            await this.$loadResource({
                size: this.perPage,
                page: this.page,
                params: this.filtro,
            })

        },


        clearForm() {

            this.form = {
                tipoProblema: {},
                itemBemPermanente: {},
                usuario: {},
                numTombamento: '',
                numTombamentoAte: '',
                dataDe: null,
                dataAte: null,
                unidadeAdministrativa: {},
                justificativa: '',
            };



            if (this.item && this.item.id) {
                this.form.unidadeAdministrativa = this.item.lotacao.departamento;
                this.form.localArmazenamento = this.item.localArmazenamento;
                this.form.itemBemPermanente = this.item;
                this.form.itemBemPermanente.descricaoResumida = this.form.itemBemPermanente.itemRegEntrada.produto.descricaoResumida;
            }
            else {
                const brand = JSON.parse(localStorage.getItem("context"));
                this.form.unidadeAdministrativa = brand.departamento;
            }
            this.form.unidadeAdministrativa.descricao = this.form.unidadeAdministrativa.nome;

            this.load();

        },

        handleSelectUnidadeAdministrativa(departamento) {
            this.form.unidadeAdministrativa = departamento;
            this.load();
        },

        handleSelectLocal(local) {
            this.form.localArmazenamento = local;
            this.load();
        },

        handleTipoProblema(tipoProblema) {
            this.form.tipoProblema = tipoProblema;
            this.load();

        },


        handleSelectResponsavel(usuario) {
            this.form.usuario = usuario;
            this.load();
        },



    },
};
</script>